import { Badge } from "@/components/ui/badge";
import { Archive, Sparkles } from "lucide-react";

export function PipelineCard({
  pipeline,
  active,
  stagesCount,
  onClick,
  onArchive,
}: {
  pipeline: any;
  active: boolean;
  stagesCount: number;
  onClick: () => void;
  onArchive: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left border rounded-lg p-3 transition group ${
        active
          ? "border-primary bg-primary/5 shadow-sm"
          : "bg-background hover:bg-muted/40"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-sm font-semibold truncate">{pipeline.name}</span>
            {pipeline.isDefault && (
              <Badge variant="secondary" className="text-[10px] h-5">
                <Sparkles className="h-3 w-3 mr-1" />
                Padrão
              </Badge>
            )}
          </div>
          {pipeline.description && (
            <p className="text-xs text-muted-foreground mt-0.5 line-clamp-1">
              {pipeline.description}
            </p>
          )}
          <div className="mt-1.5 text-xs text-muted-foreground flex items-center gap-2">
            <span>{stagesCount} estágios</span>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onArchive();
          }}
          className="shrink-0 opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-destructive p-1"
          title="Arquivar funil"
        >
          <Archive className="h-4 w-4" />
        </button>
      </div>
    </button>
  );
}
